
<template>
    <ListDialog ref="dialog" :title="$parent.formatTitle('売掛金残高表')" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="onReportGenerate" :isRemainAfterExec="true" >
      <template slot="header" slot-scope = "{editor}">
	      <AutoComplete title="帳票テンプレート" :editor="editor" :value.sync="reportTemplate" :required="true" query="SalesCashBalanceTemplateQuery" tooltip="出力する帳票のテンプレートを選択します。【帳票テンプレート】の【帳票タイプ】が【売掛残高表】のデータを選択でき、初期値は×で消してから変更が可能です。" />
	      <AtcSegment title="部門" :editor="editor" :value.sync="segment" tooltip="ここで部門を選択をすると、選択した部門だけのデータを出力する事ができます。選択しない場合はすべての部門のデータが出力できます。" />
        <AutoComplete title="取引通貨" v-if="hasLicenseCurrency" :value.sync="currencyCode" :editor="editor" list="currency" />
        <!-- <Calendar title="限月" :editor="editor" :value.sync="closingDate" :deletable="false" :required="true" :month="true" tooltip="データを出力する月を指定します。選択した月の月初から月末までのデータが帳票に出力されます。" /> -->
        <Calendar title="期間(From)" :editor="editor" :value.sync="startDate" :deletable="false" :required="true"  :autoEntry="true" :dateFlag.sync="startDateFlag" tooltip="期間(From)時点での繰越額と、期間中の発生額・入金額・消込額、期間(To)時点での残高が表示されます。" />
	      <Calendar title="期間(To)" :editor="editor" :value.sync="endDate" :deletable="false" :required="true"  :autoEntry="true" :dateFlag.sync="endDateFlag"  tooltip="期間(From)時点での繰越額と、期間中の発生額・入金額・消込額、期間(To)時点での残高が表示されます。" />        
        <CheckBox title="集計対象" :editor="editor" :value.sync="includeClosingWaiting" list="includeClosingWaiting" tooltip="請求締待ちのデータを集計対象に含めることができます。"/>
        <RadioButton title="出力形式" :editor="editor" :value.sync="onExcelExport" list="reportStyles"/>        
        </template>
        <button slot="footer_buttons" type="button" class="btn btn-info" :disabled="$parent.favoriteDisabled" @click="$parent.onShowFavorite">{{$parent.favoriteLoaded? 'お気に入りを更新':'お気に入りに追加'}}</button>
        <button slot="footer_buttons" type="button" class="btn btn-secondary btn_delete" :disabled="$parent.favoriteDisabled" @click="$parent.onDeleteFavorite" v-if="$parent.favoriteLoaded"><i class="material-symbols-outlined small valign">delete</i></button>               
      </ListDialog> 
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityAnalyse extends Vue {

  // 商品分析表用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  // public closingDate: Date = null;
  public startDate: Date = null;
  public endDate: Date = null;  
  public segment: Common.Segment = null;
  public currencyCode : string = null;
  public hasLicenseCurrency: boolean = false;
  public includeClosingWaiting: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){        
      var query: Common.SalesCashBalanceTemplateQuery = new Common.SalesCashBalanceTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date().getCalendarDate();
    // this.closingDate = today;
    this.startDate = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.endDate = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    (this.$refs.dialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesCashBalanceQuery = new Common.SalesCashBalanceQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    // query.closingDate = this.closingDate;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.segment = this.segment;
    query.currencyCode = this.currencyCode;
    query.includeClosingWaiting = this.includeClosingWaiting;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
</script>
